module.exports = __webpack_public_path__ + "img/progetti_prjweb.34204061.png";